import { FunctionComponent } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import type { Asset } from '@schibsted-svp/svp-api-types';

import { useUpcomingLabel } from '../../hooks/useUpcomingLabel';
import { PaywallLayout } from '../PaywallLayout/PaywallLayout';
import { getDurationInMilliseconds } from '../../../../utils/datetime';
import { usePlayer } from '../../hooks/PlayerProvider';
import { getRawAsset, hasStreamProperty } from '../../../../utils/player/asset';

interface UpcomingLayoutProps {
  flightTimesStartInMilliseconds: number;
  timeToStartInMilliseconds: number;
  streamType: Asset['streamType'];
}

const FIVE_SECONDS_IN_MILLISECONDS = getDurationInMilliseconds({ seconds: 5 });

export const UpcomingLayout: FunctionComponent<UpcomingLayoutProps> = ({
  flightTimesStartInMilliseconds,
  timeToStartInMilliseconds,
  streamType,
}) => {
  const player = usePlayer();
  const asset = getRawAsset(player);
  const [isPlaylistRefreshed, setIsPlaylistRefreshed] = useState(false);

  const { label, isCountdownActive } = useUpcomingLabel(
    flightTimesStartInMilliseconds,
    timeToStartInMilliseconds,
    streamType
  );

  useEffect(() => {
    const jw = player.getJWPlayer();
    if (
      !jw ||
      isPlaylistRefreshed ||
      !hasStreamProperty(asset, 'tokenSecured') ||
      timeToStartInMilliseconds > FIVE_SECONDS_IN_MILLISECONDS
    ) {
      return;
    }

    setIsPlaylistRefreshed(true);

    const playlist = jw.getPlaylist();

    jw.load(playlist);
  }, [isPlaylistRefreshed, player, timeToStartInMilliseconds]);

  return (
    <PaywallLayout
      label={label}
      isAssetUpcoming
      isCountdownActive={isCountdownActive}
    />
  );
};
